import { Card, CardContent } from "@material-ui/core";
import { useFormikContext } from "formik";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import GovGrErrorSummary from "../../../../components/GovGrErrorSummary";

import GrGovTabs from "../../../../components/GovGrTabs";
import { FOR_ME_IS_TRUE } from "../../../../constants";
import useLocale from "../../../../hooks/useLocale";
import ApplicantDetails from "../ApplicantDetails";
import UploadDocuments from "../uploadedDocuments";

const TabArea = ({ translatedGender, docsPerKindFiltered, disableAll }) => {
  const { errors, values, touched, setFieldValue } = useFormikContext();
  const user = useSelector((state) => state?.authReducer?.user);
  const { forMe } = useParams();
  const { t } = useLocale();

  const tabs = [
    {
      tabName: t("Applicant details"),
      component: (
        <ApplicantDetails
          key={0}
          touched={touched}
          disableAll={disableAll}
          errors={errors}
          values={values}
          forMe={forMe === FOR_ME_IS_TRUE ? true : false}
          portAuthId={user?.port_auth_id}
          setFieldValue={setFieldValue}
          translatedGender={translatedGender}
        />
      ),
    },
    {
      tabName: t("Documents"),
      component: (
        <UploadDocuments
          docsPerKind={docsPerKindFiltered}
          errors={errors}
          values={values}
        />
      ),
    },
  ];

  const ApplicantDetailsError =
    Object.keys(errors)?.filter((error) => error !== "documents")?.length !==
    0 && Object.keys(touched)?.length !== 0;

  const ApplicantFieldNamesIdFirstInArray = Object.keys(errors)?.filter(
    (error) => error !== "documents"
  )[0];

  const ApplicantDocumentsMissing = !!errors["documents"];

  const errorSummary = useMemo(() => {
    return [
      ...(ApplicantDocumentsMissing ? [{ error: errors["documents"] }] : []),
      ...(ApplicantDetailsError
        ? [
          {
            error: t("Required Applicant Details missing"),
            linkToErrorName: ApplicantFieldNamesIdFirstInArray,
          },
        ]
        : []),
    ];
  }, [ApplicantDocumentsMissing, ApplicantDetailsError]);

  return (
    <Card>
      <CardContent>
        <GovGrErrorSummary errorsummary={errorSummary} />
        <GrGovTabs inputTable={tabs} />
      </CardContent>
    </Card>
  );
};

export default TabArea;
